var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpiYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 -10 20 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7584 12.4004C17.3594 12.4004 16.9603 12.7003 16.9603 13.2003V15.2001C16.9603 15.9001 16.3617 16.4001 15.7631 16.4001H13.7678C13.3687 16.4001 12.9697 16.7 12.9697 17.2C12.9697 17.6999 13.269 18 13.7678 18H15.7631C17.2596 18 18.5565 16.8 18.5565 15.2001V13.2003C18.5565 12.8004 18.1575 12.4004 17.7584 12.4004Z",
    fill: "url(#paint0_linear_2949_3104)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7678 2.00125H15.7631C16.4615 2.00125 16.9603 2.60119 16.9603 3.20115V5.20098C16.9603 5.60095 17.2597 6.00092 17.7585 6.00092C18.2573 6.00092 18.5566 5.70095 18.5566 5.20098V3.20115C18.5566 1.70127 17.3594 0.401367 15.7631 0.401367H13.7678C13.3688 0.401367 12.9697 0.701345 12.9697 1.2013C12.9697 1.70127 13.3688 2.00125 13.7678 2.00125Z",
    fill: "url(#paint1_linear_2949_3104)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78677 16.4001H3.79147C3.09311 16.4001 2.59429 15.8001 2.59429 15.2001V13.2003C2.59429 12.8004 2.295 12.4004 1.79616 12.4004C1.29734 12.4004 0.998047 12.8004 0.998047 13.2003V15.2001C0.998047 16.7 2.19523 18 3.79147 18H5.78677C6.18584 18 6.5849 17.6999 6.5849 17.2C6.5849 16.7 6.18584 16.4001 5.78677 16.4001Z",
    fill: "url(#paint2_linear_2949_3104)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79616 6.00092C2.19523 6.00092 2.59429 5.70095 2.59429 5.20098V3.20115C2.59429 2.5012 3.19289 2.00125 3.79147 2.00125H5.78678C6.18584 2.00125 6.5849 1.70127 6.5849 1.2013C6.5849 0.701345 6.18584 0.401367 5.78678 0.401367H3.79147C2.295 0.401367 0.998047 1.70127 0.998047 3.20115V5.20098C0.998047 5.60095 1.3971 6.00092 1.79616 6.00092Z",
    fill: "url(#paint3_linear_2949_3104)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7675 15.2C14.865 15.2 15.7629 14.3002 15.7629 13.2002V11.4004H3.79102V13.2002C3.79102 14.3002 4.68891 15.2 5.78633 15.2H13.7675Z",
    fill: "url(#paint4_linear_2949_3104)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7559 8.40073H15.763V5.20101C15.763 4.1011 14.865 3.20117 13.7676 3.20117H5.78639C4.68897 3.20117 3.79108 4.1011 3.79108 5.20101V8.60076H0.798126C0.399058 8.60076 0 8.90072 0 9.40072C0 9.90062 0.299294 10.2006 0.798126 10.2006H18.7559C19.1549 10.2006 19.554 9.90062 19.554 9.40072C19.554 8.90072 19.1549 8.40073 18.7559 8.40073Z",
    fill: "url(#paint5_linear_2949_3104)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2949_3104",
    x1: 14.2623,
    y1: 15.5663,
    x2: 18.5164,
    y2: 15.5653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2949_3104",
    x1: 14.2623,
    y1: 3.5673,
    x2: 18.5164,
    y2: 3.56628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2949_3104",
    x1: 2.29067,
    y1: 15.5663,
    x2: 6.54475,
    y2: 15.5653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2949_3104",
    x1: 2.29067,
    y1: 3.5673,
    x2: 6.54475,
    y2: 3.56628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2949_3104",
    x1: 6.56092,
    y1: 13.5487,
    x2: 15.6769,
    y2: 13.5418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2949_3104",
    x1: 4.52417,
    y1: 7.15856,
    x2: 19.4135,
    y2: 7.14858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpiYellow);
export default __webpack_public_path__ + "static/media/upi-yellow.cf439ef255547d817e8f3d96746faa85.svg";
export { ForwardRef as ReactComponent };